<template>
    <div class="content-wrappper">
       <div class="row account-settings-main m-0">
       <div class="col-md-12 col-sm-12 col-xs-12 pr-0 pl-0 accounts-settings-title">

           <div>{{$t('accountSettings')}}</div>
           <div class="close-icon cursor-pointer" @click="$router.push('/layout/dashboard')">
             <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
           </div>

       </div>
       <div class="col-md-12 col-sm-12 col-xs-12 account-settings-body pl-24 pr-24 pb-24 " style="background-color: #E5E5E5">
         <div class="sub-menus">
         <AccountSettingsLeftNav  :roleId="role_id" :roleInfo="roleInfo"></AccountSettingsLeftNav>
       </div>
       </div>

       </div>

 </div>
</template>
<script>
import EventBus from '../../utils/event-bus';
import AccountSettingsLeftNav from './AccountSettingsMain.vue';

export default {
  props: {
    roleInfo: Object
  },
  components: {
    AccountSettingsLeftNav,
  },
  data() {
    return {
      user_id: '',
      role_id: '',
      account_id: '',
    };
  },
  created() {
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    this.user_id = JSON.parse(localStorage.getItem('userId'));
    this.role_id = JSON.parse(localStorage.getItem('roleId'));
    this.account_id = JSON.parse(localStorage.getItem('accountId'));
  },

};

</script>

<style scoped>
.account-settings-main{
   background-color: #E5E5E5 !important;
   height: calc(100vh - 50px) !important;
}
.sub-menus {
 background-color: #FFFFFF !important;
 border: 1px solid #B3B3B3;

}
.accounts-settings-title {
   padding:24px 25px 20px 29px;
   font-weight: 400;
   font-size: 24px;
   line-height: 34px;
   color: #3E3E3E;
   display: flex;
   justify-content: space-between;

}
</style>
